function DownloadCard({ title, description, linkandroid, linkios, icon }) {
  return (
    <div className="card mb-3 download-card">
      <div className="card-body d-flex align-items-center">
        {icon && (
          <img
            src={icon}
            alt={`${title} icon`}
            className="download-icon me-3"
            
          />
        )}
        <div className="flex-grow-1">
          <h5 className="card-title">{title}</h5>
          {description && <p className="card-text">{description}</p>}
          <div className="d-flex gap-2">
            {linkandroid && (
              <a
                href={linkandroid}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-success btn-sm d-flex align-items-center"
              >
                <i className="bi bi-android2 me-1"></i> Android
              </a>
            )}
            {linkios && (
              <a
                href={linkios}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-dark btn-sm d-flex align-items-center"
              >
                <i className="bi bi-apple me-1"></i> iOS
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}



function Descargas() {
  const apps = [
    {
      title: 'SmartPanics',
      description: 'Descargá la app SmartPanics para tu dispositivo Android o iOS y gestioná alertas, ubicaciones y más desde tu celular.',
      linkandroid: 'https://play.google.com/store/apps/details?id=com.softguard.android.smartpanicsNG&hl=es_UY',
      linkios: 'https://apps.apple.com/es/app/smartpanics/id1058553591',
      icon: '/img/apps/SP.png',
    },
    {
      title: 'App Hik-Conect 6',
      description: 'Aplicación oficial para cámaras y paneles Hikvision.',
      linkandroid: 'https://www.hikvision.com/download/',
      linkios: 'https://apps.apple.com/cr/app/hik-connect/id1087803190',
      icon: '/img/apps/hik.webp',
    },
    {
      title: 'App DMSS Dahua',
      description: 'Aplicación oficial para cámaras Dahua.',
      linkandroid: 'https://www.dahuasecurity.com/downloads/',
      linkios: 'https://apps.apple.com/es/app/dmss/id1493268178',
      icon: '/img/apps/dmss.webp',
    },
  ];

  const manuals = [
    {
      title: 'Manual de panel DSC 1832',
      link: '/manuales/manual-panel-dsc.pdf',
    },
    {
      title: 'Manual de panel DSC Neo',
      link: '/manuales/manual-panel-dsc-neo.pdf',
    },
    {
      title: 'Manual de panel Hikvision AxHome / AxPro /AxHibryd',
      link: '/manuales/guia-hikvision.pdf',
    },
    {
      title: 'Manual de panel Intelbras AMT 2018 / 4010 / 8000',
      link: '/manuales/configuracion-app-monitoreo.pdf',
    },

    {
      title: 'Manual de panel Ajax Hub',
      link: '/manuales/configuracion-app-monitoreo.pdf',
    },

    {
      title: 'Manual de panel Paradox SP6000+',
      link: '/manuales/configuracion-app-monitoreo.pdf',
    },

    {
      title: 'Guía de uso de App SmartPanic',
      link: '/manuales/configuracion-app-monitoreo.pdf',
    },

    {
      title: 'Guía de uso de App DMSS para camaras Dahua',
      link: '/manuales/dahua_dmss.pdf',
    },

    {
      title: 'Guía de uso de de Hik-Conect 6 para camaras Hikvision y Hilook',
      link: '/manuales/configuracion-app-monitoreo.pdf',
    },

    {
      title: '',
      link: '/manuales/configuracion-app-monitoreo.pdf',
    },

  ];

  return (
    <main className="container my-4">
      <h1 className="mb-3 text-white">Accedé a nuestras aplicaciones móviles y manuales de usuario</h1>
      <div className="row">
        {/* Columna izquierda: Apps */}
        <div className="col-md-6 d-flex flex-column">
          {apps.map(({ title, description, linkandroid, linkios, icon }, idx) => (
            <DownloadCard
              key={idx}
              title={title}
              description={description}
              linkandroid={linkandroid}
              linkios={linkios}
              icon={icon}
            />
          ))}
        </div>

        {/* Columna derecha: Manuales */}
        <div className="col-md-6">
          <h2 className="h5 mb-3 text-white">Manuales:</h2>
          <ul className="list-group">
            {manuals.map(({ title, link }, idx) => (
              <li key={idx} className="list-group-item">
                <a
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  {title}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </main>
  );
}

export default Descargas;
